import { globalIsInApp } from '@common/application/store/global';
import { useRecoilValue } from 'recoil';
// 判断是否在 RN 环境中，基于 hooks 防止出现 react-hydration-error
export const useInRN = () => {
    return useRecoilValue(globalIsInApp);
};
